import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { getAPIURL } from "helpers";
import { getBaseQueryWithRejection } from "redux/helper.redux";

const baseQueryWithRejection = getBaseQueryWithRejection(
    fetchBaseQuery({
        baseUrl: getAPIURL("/api/list"),
        prepareHeaders: (headers, { getState }) => {
            const token = getState().auth.accessToken;
            if (token) {
                headers.set("Authorization", `Bearer ${token}`);
            }
            return headers;
        },
    })
);


export const listsApi = createApi({
    reducerPath: "listsApi",
    baseQuery: baseQueryWithRejection,
    tagTypes: [],
    endpoints: (builder) => ({
        getListByMasterKey: builder.query({
            query: ({ key, params }) => {
                params = params ?? {};
                const tmp = new URLSearchParams();
                for (const x in params) {
                    tmp.append(x, params[x]);
                }
                return `/master-key/${key}?${tmp.toString()}`;
            },
            transformResponse: (response) => response.data,
            providesTags: [],
        }),
        getListByMasterId: builder.query({
            query: ({ id, params }) => {
                params = params ?? {};
                const tmp = new URLSearchParams();
                for (const x in params) {
                    tmp.append(x, params[x]);
                }
                return `/master/${id}?${tmp.toString()}`;
            },
            transformResponse: (response) => response.data,
            providesTags: [],
        }),
    }),
});


export const {
    useGetListByMasterKeyQuery,
    useLazyGetListByMasterKeyQuery,
    useGetListByMasterIdQuery,
    useLazyGetListByMasterIdQuery,
} = listsApi;
